import { isEmpty } from 'lodash';

import { ProviderTypes, ReverseCoverageTypesCodes } from '../common/Constants';

export const isVisionServiceSpeciality = (
  enableVisionServicesOfferedSpecialityTransform: boolean,
  isOnlineProvider: boolean,
  coverageType?: string,
  providerType?: string,
  servicesOffered?: string[],
  isOnlineRetailersSearch = false
): boolean =>
  providerType?.toLocaleLowerCase() === ProviderTypes.ORGANIZATION &&
  coverageType === ReverseCoverageTypesCodes.VISION &&
  (isOnlineProvider || isOnlineRetailersSearch) &&
  enableVisionServicesOfferedSpecialityTransform &&
  !isEmpty(servicesOffered);
